import { Directive, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Directive({
  selector: '[number-input]',
  host: { '(ionChange)': 'onValueChange($event)' }
})
export class NumberInputDirective {

  @Input() control: FormControl;

  constructor() { }

  onValueChange(ev) {
    if (!ev.value) return;
    const value = parseInt(ev.value);
    this.control.setValue(value);
  }

}


// WEBPACK FOOTER //
// ./src/directives/number-input/number-input.directive.ts